export class FormatRegistrationResult {
  constructor(public isRegistered: boolean, public detail: IFormatRegistrationResultDetail) {
  }
}

export interface IFormatRegistrationResultDetail {
}

export interface IFormatRegistrationResultRegisteredDetail extends IFormatRegistrationResultDetail {
  id: number;
  archiveId: number;
}

export interface IFormatRegistrationResultAlreadyUpdatedDetail extends IFormatRegistrationResultDetail {
  isDeleted: boolean;
  edition: number;
  updated: {
    userName: string;
    terminal: string;
    dateTime: Date;
  };
}
